angular.module('metadata.service', ['ngResource']);